import { Helmet } from 'react-helmet-async';
// sections
import ClinicAddPackageView from 'src/sections/clinic-dashboard/packages/clinic-package-add-view';
import EditClinicPackageView from 'src/sections/clinic-dashboard/packages/edit-clinic-package-view';

// ----------------------------------------------------------------------

export default function ClinicEditPackagePage() {
  return (
    <>
      <Helmet>
        <title>Edit Package</title>
      </Helmet>

      <EditClinicPackageView />
    </>
  );
}
